module.exports = __webpack_public_path__ + "static/media/delete-template.9beeff5e.png";